import { Shirt, Workflow, TrendingUp } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const icons = [Shirt, Workflow, TrendingUp];

export default function Features() {
  const { t } = useI18n();

  return (
    <section className="py-16 lg:py-20 border-t border-border">
      <div className="mx-auto max-w-container px-6 lg:px-10">
        <div className="max-w-prose mb-10 reveal">
          <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-3">
            {t.home.featuresEyebrow}
          </div>
          <h2 className="font-serif text-[36px] lg:text-[44px] leading-[1.1] tracking-tight">
            {t.home.featuresTitle}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-10 lg:gap-14">
          {t.home.features.map(([title, body], i) => {
            const Icon = icons[i];
            return (
              <div key={title} className="reveal" style={{ transitionDelay: `${i * 80}ms` }}>
                <Icon className="h-6 w-6 text-primary" strokeWidth={1.4} />
                <h3 className="font-serif text-2xl mt-4 mb-2">{title}</h3>
                <p className="text-[15px] text-muted-foreground leading-relaxed">{body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
